import type { ReactNode } from 'react';

export const symbol_keep_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M574-780H380v140L218-802q-4-4-5-7t-1-8q0-8.79 5.5-15.9Q223-840 234-840h400q12.75 0 21.38 8.62Q664-822.75 664-810q0 12-10.87 16.87Q642.25-788.25 634-780v327q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-327ZM450-70v-241H271q-17.27 0-27.64-12Q233-335 233-348.88q0-6.94 2.84-13.87 2.84-6.94 9.16-13.25l75-72v-84L76-776q-9-9-9-21t9-21q9-9 21-9t21 9l707 708q9 9 9 21t-9 21.39Q816-59 804-59t-21-9L540-311h-30v241q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q450-57.25 450-70ZM321-371h159L380-471v45l-59 55Zm156-172Zm-97 72Z"
		/>
	</svg>
);
